<article class="node node-news view-mode-teaser_image_title clearfix">
  <header></header>
  <div class="field field-name-news-main-photo field-type-image field-label-hidden">
  <div class="field-items">
    <div class="field-item even">
      <a [href]="new.url" tabindex="0">
        <img
          typeof="foaf:Image"
          [src]="new.photo != undefined ? new.photo.src : blankImage"
          alt=""
        />
      </a>
    </div>
  </div>
  </div>

  <div class="field field-name-field-subtitle field-type-text field-label-hidden">
    <div class="field-items">
      <div class="field-item even">
        <div class="content-category">{{ new.field_content_category }}</div>
        <h3><a [href]="new.url" tabindex="0">{{ new.title }}</a></h3>
        <div class="content-date">{{new.field_publish_date}}</div>
      </div>
    </div>
  </div>
</article>
